<template>
  <v-row>     
    <div class="col-md-12 home-box">
      <Breadcrumbs :title="'Reports'"></Breadcrumbs>
      <UserAvailability></UserAvailability>
    </div>
    <div class="col-md-12 home-tabs-body">
    </div>
  </v-row>
</template>

<script>

import { createNamespacedHelpers } from "vuex";
import UserAvailability from "@/components/reports/UserAvailability";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "Reports",
  components: {
    Breadcrumbs,
    UserAvailability
  },
  data: function () {
    return {
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      profile: "profile"
    })
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.$store.dispatch("settings/getCompanySettings");
  },

  watch: {

  },

  methods: {

  },

};
</script>
